import { Backdrop, CircularProgress } from '@mui/material'
import React from 'react'
// import { Modal, Row } from 'react-bootstrap'
// import { BallTriangle } from 'react-loader-spinner'


function Loading(props) {
    return (

        <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={props.isShow}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    )
}

export default Loading